import InitComponent from './InitComponent';
import initComponentReducer from './reducer';

export { initComponentReducer };
export default InitComponent;
